import HTMLView from '@components/HTMLView'
import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import styled from 'styled-components'

const allowedHtmlTags = ['p', 'em', 'strong', 'a', 'sub', 'sup']

interface SourceProps {
  text: string
}

const StyledSource = styled.div`
  p {
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.6px;
    margin: 0;
  }
`

const Source: FunctionComponent<SourceProps> = ({ text }) => (
  <StyledSource>
    <HTMLView content={text} allowedHtmlTags={allowedHtmlTags} />
  </StyledSource>
)

const widget: CookWidget = {
  kind: ['widget', 'source'],
  component: Source,
}

export default widget
